<div class="d-flex gap-1 px-1 state-indicator align-items-center w-fit" [ngClass]="[cssClasses, state].join(' ')">
  <ng-container [ngSwitch]="state">
    <broker-check-filled-svg *ngSwitchCase="'accept'"></broker-check-filled-svg>
    <broker-warning-svg *ngSwitchCase="'refer'"></broker-warning-svg>
    <broker-decline-svg *ngSwitchCase="'decline'"></broker-decline-svg>
  </ng-container>
  <p class="m-0">{{ 'consumer.offer.expansion-panel.state.' + state | translate: lang }}</p>
</div>
